{
  "$schema": "./skinning_variables.schema.json",
  "### This JSON keeps overwrites of the lightmode for generic (=whitelabel =with branding module) partners.": "",
  "igColorEmptystateIcon": "#555555",
  "igColorHotspot": "$accentColor",
  "tableHeaderCheckboxBorderColor": "$inputCheckboxBorder"
}
